'use client';
import React from "react";
import SubScrip from "./SubScrip";
import FooterComponent from "./FooterComponent";
export default function Footer() {
  

  return (
    <div className="relative">
      <SubScrip/>
      <FooterComponent className="pt-[10rem]"/>
    </div>
  );
}
